import { Injectable,Inject } from '@angular/core';
import { Http, Response,Headers,RequestOptions, URLSearchParams } from '@angular/http'; 
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import "rxjs/add/operator/map";
import {Observable} from "rxjs/Observable"; 
import { ConstantsService } from './constants.service';

@Injectable()
export class GeneralServices {
    public url:string;

  constructor(
    private _http: Http,
    private router: Router,
    private constants: ConstantsService
    ) {
  	this.url = constants.apiURL;
  }  

  getWithAuth(){
    let headers = new Headers({  
      'Authorization': 'Bearer <SESSION TOKEN>'
  });
    let options = new RequestOptions({ headers: headers }); 
   
    return this._http.get(this.url,options)
    .map(res=>res.json()); 
  }

  get(){
    return this._http.get(this.url)
    .map(res=>res.json()); 
  }

  
  post(data){
    return this._http.post(this.url,data)
    .map(res=>res.json()); 
  }

  put(data){
    return this._http.put(this.url,data)
    .map(res=>res.json()); 
  }

  delete(id){
    return this._http.delete(this.url+id)
    .map(res=>res.json()); 
  }

}


// WEBPACK FOOTER //
// ./src/app/services/general.services.ts